// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Y0iH","paramInput":"JobSimulator_paramInput__2cKNW","input":"JobSimulator_input__11lK9"};